import { MenuItem } from 'generated/graphql';
import useOnPathChange from 'hooks/onPathChange';
import { useCallback, useEffect, useState } from 'react';
import { LevelTwoAnimationWrapper } from '../LevelTwoAnimationWrapper';
import { LevelThreeLinks } from './components/LevelThreeLinkts';
import { CenteredItemLink } from '../CenteredItemLink';

type LevelTwoLinksProps = {
    listItem: MenuItem;
    isFocused: boolean;
};

export function LevelTwoLinks({ listItem, isFocused }: LevelTwoLinksProps) {
    const [activeItem, setActiveItem] = useState<MenuItem>();
    const closeSubMenu = useCallback(() => setActiveItem(undefined), []);
    const [focusLastRender, setFocusLastRender] = useState(false);

    useOnPathChange(closeSubMenu);
    useEffect(() => {
        if (!isFocused) {
            setActiveItem(undefined);
        }
        setFocusLastRender(isFocused);
    }, [focusLastRender, isFocused]);

    return (
        <LevelTwoAnimationWrapper
            showLevelThree={Boolean(activeItem)}
            levelThreeChildren={(
                <LevelThreeLinks
                    listItem={activeItem!}
                    closeSubMenu={closeSubMenu}
                />
            )}
            levelTwoChildren={(listItem.items.map((item, itemIndex) => {
                const isParent = item.items.length > 0;

                return (
                    <CenteredItemLink
                        key={itemIndex}
                        item={item}
                        onClick={isParent ? () => setActiveItem(item) : undefined}
                    />
                );
            })
            )}
        />
    );
}
